import api from './axiosInstance';
export const getAll = () => api.get('/makes');
export const getById = (id) => api.get(`/makes/${id}`);
export const create = (data) => api.post('/makes', data);
export const update = (id, data) => api.put(`/makes/${id}`, data);
export const remove = (id) => api.delete(`/makes/${id}`);
export const batchRemove = (ids) => api.post('/makes/batch-delete', { ids });
